module.exports = __webpack_public_path__ + "img/C04TechSparabara3_ua.e3597f74.webp";